import { defineComponent as _defineComponent } from 'vue';
import { useSearchWizardStore } from '#imports';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'FilterAndSortFacetsGroupRanked',
  props: {
    group: null,
    counts: null,
    initialFacetCounts: null,
    selectedFacets: null
  },
  emits: ['facetsChange'],
  setup(__props, _ref) {
    var {
      emit
    } = _ref;
    var props = __props;
    var searchWizardStore = useSearchWizardStore(usePinia());
    var facets = computed(() => props.group.facets);
    function isFacetActive(slug) {
      return !searchWizardStore.showCount || !!props.counts[slug] && !facetsBelowSelected.value.includes(slug);
    }
    function facetChange(changedSlug, checked) {
      var newSelected = facetSlugs.value.map(slug => [slug, slug === changedSlug ? checked : false]);
      emit('facetsChange', newSelected);
    }
    var facetSlugs = computed(() => {
      return props.group.facets.map(_ref2 => {
        var {
          slug
        } = _ref2;
        return slug;
      });
    });
    var facetsBelowSelected = computed(() => {
      var selectedFacetIndex = facetSlugs.value.findIndex(slug => props.selectedFacets.includes(slug));
      return selectedFacetIndex > -1 ? props.group.facets.slice(selectedFacetIndex + 1).map(_ref3 => {
        var {
          slug
        } = _ref3;
        return slug;
      }) : [];
    });
    return {
      __sfc: true,
      props,
      searchWizardStore,
      emit,
      facets,
      isFacetActive,
      facetChange,
      facetSlugs,
      facetsBelowSelected
    };
  }
});